import * as React from "react";
import clsx from "clsx";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../../components/colors";
import { useGetCountries } from "../../../service/api";
import { useHandleFetchError } from "../../../error-handler";

interface OwnProps {
  name: string;
  label: string;
  helpText?: string;
  defaultValue?: string | string[] | number | undefined;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  isRequired?: boolean;
}

export const SelectCurrencyFormField: React.FC<OwnProps> = (props) => {
  const errors = props.errors;
  const hasError = !!errors?.[props.name];
  const errorMessage = errors?.[props.name]?.message as string;

  const {
    data: countries,
    isLoading,
    error: getCountriesError,
  } = useGetCountries();
  const selectCurrencyOptions = new Set(
    countries?.filter((c) => !!c.enabled).map((c) => c.currency)
  );

  useHandleFetchError(getCountriesError);

  if (isLoading) {
    return null;
  }

  return (
    <div className={clsx({ "form-group w-100": true, "has-error": hasError })}>
      {props.label && (
        <StyledText
          color={colors.textPrimary}
          className="bodySubtextSemibold mb-2"
        >
          {props.label}
        </StyledText>
      )}
      <select
        className="form-control"
        defaultValue={props.defaultValue}
        {...props.register(props.name as any)}
        required={props.isRequired}
      >
        {[...selectCurrencyOptions]?.map((currency, i) => {
          return (
            <option key={i} value={currency}>
              {currency}
            </option>
          );
        })}
      </select>
      {hasError && (
        <StyledText
          color={colors.errorDark}
          className="bodySubtextRegular mt-2"
        >
          {errorMessage}
        </StyledText>
      )}
      {props.helpText && (
        <StyledText
          color={colors.textSecondary}
          className="bodySubtextRegular mt-2"
        >
          {props.helpText}
        </StyledText>
      )}
    </div>
  );
};
